import React from "react";
import { clsx } from "clsx";
import dayjs from "dayjs";
import { Link } from "gatsby";

interface IArticleThumbnailProps extends React.PropsWithChildren {
  post: Queries.MicrocmsPost;
}

export default function ArticleThumbnail(props: IArticleThumbnailProps) {
  const { post } = props;
  const { category, eyecatch, postId, publishedAt: _publishedAt, title } = post;

  const publishedAt = dayjs(_publishedAt);

  return (
    <Link
      className={clsx("card", "card-compact", "shadow-xl")}
      to={`/posts/${postId}`}
    >
      <figure>
        <img src={eyecatch?.url ?? ""} alt="article" />
      </figure>
      <div className="card-body">
        <div className={clsx("flex", "text-xs")}>
          <p className={clsx("font-light")}>
            {publishedAt.format("YYYY/MM/DD")}
          </p>
          <p className={clsx("text-end", "text-primary")}>#{category?.name}</p>
        </div>
        <h2 className="break-all card-title">{title}</h2>
      </div>
    </Link>
  );
}
